exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chipwidth[data-v-7f830a20]{min-width:24px;height:24px!important}.text-box[data-v-7f830a20]{border:1px solid #ccc;width:100%;padding:4px}.question-title[data-v-7f830a20]{display:flex;justify-content:space-between}.question-title .question-explanation[data-v-7f830a20]{display:flex;flex-direction:column;justify-content:flex-start}.question-title .question-explanation[data-v-7f830a20]:after{background-color:transparent}.question-help-col[data-v-7f830a20]{display:flex;flex-direction:column;justify-content:flex-start;padding:24px}", ""]);

// exports
